<template>
  <v-app-bar fixed clipped-top app class="header thick-border-top">
    <v-app-bar-nav-icon @click="setDrawer"></v-app-bar-nav-icon>

    <v-menu transition="slide-y-transition" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="darken-2 mx-0 px-0">
          <v-icon>notifications</v-icon>
        </v-btn>
      </template>
      <v-list class="notification-popup-list">
        <v-list-item two-line v-for="(item, i) in notifications" :key="i">
          <v-list-item-content>
            <v-list-item-title>{{ item.header.substring(0, 50) }}</v-list-item-title>
            <!--<v-list-item-subtitle>{{ item.body.substring(0, 50) }}</v-list-item-subtitle>-->
          </v-list-item-content>
          <!--<v-list-item-action>
            <v-icon v-if="item.status == 'new'" color="primary darken-2">notifications</v-icon>
            <v-icon v-else color="grey lighten-1">notifications</v-icon>
          </v-list-item-action>-->
        </v-list-item>
        <v-list-item>
          <router-link :to="BACKEND_URL + '/my-notifications'" md12 class="d-block">
            <v-btn x-small class="see-more-btn primary darken-2 d-block">{{ $t("global.see_more") }}</v-btn>
          </router-link>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu transition="slide-y-transition" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="darken-2">
          <v-icon class="pr-2">language</v-icon>
          ({{ $locale_bcp47(current_locale) }})
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in locales" :key="i">
          <v-btn text md12 @click="locale(item.key)" class="darken-2">{{ item.text }}</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer></v-spacer>

    <v-menu transition="slide-y-transition" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="pa-0 darken-2">
          {{ $t("global.welcome") }}
          {{ typeof user.person !== "undefined" ? user.person.first_name + " " + user.person.last_name : "" }}
          <v-icon class="pl-2">arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, i) in items" :key="i">
          <v-btn text md12 @click="menu(item.value)" class="darken-2">{{ item.title }}</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      drawer: false,
      locales: this.$dd_locales(),
      current_locale: this.$getSetting("locale")
    }
  },

  computed: {
    items() {
      return [
        { title: this.$t("global.my_profile"), value: "profile" },
        // { title: this.$t("global.manuals"), value: "manual" },
        { title: this.$t("settings.title"), value: "settings" },
        { title: this.$t("auth.logout"), value: "logout" }
      ]
    },
    notifications() {
      return this.$store.getters["notification/recentNotifications"]
    },
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    }
  },

  methods: {
    setDrawer() {
      this.$toggleDrawer()
    },

    menu(value) {
      switch (value) {
        case "profile":
          this.$router.push("profile")
          break
        case "manual":
          window.open("https://rise.articulate.com/share/XZdHtKGCE7c9jgIyFirjxJ-VoWf4Ipmm#/", "_blank")
          break
        case "settings":
          this.$router.push("settings")
          break
        case "logout":
          this.$clearCookies()
          this.$store.dispatch("settings/reset", this)
          this.$store.dispatch("auth/logout", this)
          break
      }
    },

    locale(val) {
      this.$localeChange(val)
      this.current_locale = val
    }
  }
}
</script>
